import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Update project")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Delete project")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Really delete this project?")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" This will delete the project and its accociated grid.")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_flex_project_form_component = _resolveComponent("flex-project-form-component")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_flex_project_form_component, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_text, {
            color: _ctx.message.error ? 'danger' : 'success'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message.text), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_ion_button, {
            slot: "end",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            slot: "end",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(true))),
            color: "danger"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isOpenRef,
        onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOpen(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"space-between"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOpen(false)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _ctx.onDelete,
                        color: "danger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    _: 1
  }))
}